module.exports = __webpack_public_path__ + "assets/img/5_1144.9c546e0c.jpg";